import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import router from '@/router';
import * as API from '@/api'

function initialState() {
    return {
            film_genre: [],
            film_media: [],
            film_rights: [],
            territories: [],
            languages: [],
    };
}

const state = initialState();

// actions

const actions = {

    async list(context,payload) {
        var response = await API.adminTag.list(payload)
        context.commit('set_list', {
            tags: response.tags,
            tag_type: payload.type
        })
        return response;
    },

    async create(context,payload) {
        var response = await API.adminTag.create(payload)
        return response;
    },

    async delete(context,payload) {
        var response = await API.adminTag.delete(payload)
        return response;
    },

    async update(context,payload) {
        var response = await API.adminTag.update(payload)
        return response;
    },

}

// getters
const getters = {
    getField,
    getTag: (state) => (id, type) => {
        var tag =  state[type].find(tag => {
            return tag.id == id
        });
        return tag
    },
};

// mutations
const mutations = {
    updateField,
    set_list(state,payload) {
        state[payload.tag_type] = payload.tags
    },

    reset (state) {
        // acquire initial state
        const s = initialState ();
        Object.keys (s).forEach (key => {
          state[key] = s[key];
        });
    },

}


export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
